export class ChunkContext {
    constructor() {
        this.chunkIndex = 0;
        this.chunkSize = 1;
    }
    next() {
        if (!this.isInitialized()) {
            return true;
        }
        if (this.isEnd()) {
            return false;
        }
        this.chunkIndex += this.chunkSize;
        return true;
    }
    init(totalChunk) {
        this.totalChunk = totalChunk;
    }
    isInitialized() {
        return this.totalChunk !== undefined;
    }
    isEnd() {
        if (!this.isInitialized()) {
            return false;
        }
        return this.chunkIndex + this.chunkSize >= this.totalChunk;
    }
    getChunkOptions() {
        return {
            chunkIndex: this.chunkIndex,
            chunkSize: this.chunkSize,
        };
    }
}
//# sourceMappingURL=chunk-context.js.map